module.exports = __webpack_public_path__ + "static/35-Comcast-b6e18a06529b8a5eefa4a4dcc917a651.png";